import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, Icon, Button, List, Label } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import TextField from 'material-ui/TextField';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

// import classNames from 'classnames/bind';
// import styles from './ExamTemplateCopy.css';
// const cx = classNames.bind(styles);

class PhishingTemplateCopy extends PureComponent {
  constructor(props) {
    super(props);
  }

  handleOnChangeServiceNo = e => {
    const { recordServiceNo } = this.props;
    recordServiceNo(e.target.value);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const {
      isAuth,
      coping,
      errorMessage,
      phishingInfo,
      copyTemplate,
      onInitErrorMessage,
      handleOnToggleCopyModal
    } = this.props;
    const { handleOnChangeServiceNo } = this;

    // const { templateNo, serviceTemplateNo, templateName, serviceNo, regEpoch } = templateInfo;
    const { isBasic, phishingNo, phishingName, regEpoch } = phishingInfo;
    
    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={'modal-admin modal-examTemplate-copy common-content'}
        closeIcon
        onToggleModal={handleOnToggleCopyModal}
        visible
        header={
          <div>
            {defineMessages(formatMessage({ id: 'PhishingTemplateCopyModal_1', defaultMessage: '피싱 페이지 복제' }))}
          </div>
        }
        buttons={
          <div className={'inline-block'}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleCopyModal}>
              {defineMessages(formatMessage({ id: 'ExamTemplateCopy_2', defaultMessage: '취 소' }))}
            </Btn>
            <Btn className={'brand-button'} loading={coping} disabled={coping} onClick={copyTemplate}>
              {defineMessages(formatMessage({ id: 'ExamTemplateCopy_11', defaultMessage: '복 제' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={coping}
          size="small"
          content={defineMessages(formatMessage({ id: 'ExamTemplateCopy_4', defaultMessage: '복제중...' }))}
        />
        <div className={'message-header'}>
          {defineMessages(
            formatMessage({
              id: 'PhishingTemplateCopyModal_2',
              defaultMessage: '피싱페이지를 복제하여 새로 생성합니다.'
            })
          )}
          <br />
          {defineMessages(
            formatMessage({
              id: 'PhishingTemplateCopyModal_3',
              defaultMessage: '다음 피싱페이지를 복제합니까?'
            })
          )}
        </div>
        <Message className={'template-detail-box'}>
          <div className={'template-detail'}>
            <List bulleted className={'template-detail-list'}>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>No</div>
                {isBasic
                  ? phishingNo +
                  ' ' +
                  defineMessages(formatMessage({ id: 'ExamTemplateCopy_6', defaultMessage: '(기본 제공)' }))
                  : phishingNo}
              </List.Item>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateCopy_7', defaultMessage: '템플릿명' }))}
                </div>
                {phishingName}
              </List.Item>
              <List.Item className={'template-detail-item'}>
                <div className={'template-detail-item-title'}>
                  {defineMessages(formatMessage({ id: 'ExamTemplateCopy_8', defaultMessage: '등록일시' }))}
                </div>
                {common.timeFormatFromUTCEpoch(regEpoch)}
              </List.Item>
            </List>
            {isAuth === 2 && (
              <List className={'template-detail-list'}>
                <span className={'materialTextField-title'}>
                  {defineMessages(
                    formatMessage({
                      id: 'PhishingTemplateCopyModal_4',
                      defaultMessage: '대상 서비스 번호 (미입력 시 비공개 기본 피싱페이지로 복제)'
                    })
                  )}
                </span>
                <List.Item className={'template-detail-item', 'input-parent'}>
                  <TextField
                    className={'input-area'}
                    error={!!errorMessage}
                    fullWidth
                    onChange={handleOnChangeServiceNo}
                    onKeyUp={onInitErrorMessage}
                  />
                  {!!errorMessage && (
                    <Label className={'pointing-label'} basic pointing>
                      {defineMessages(formatMessage({ id: 'LicenseEdit_50', defaultMessage: '잘못된 서비스 번호입니다.' }))}
                    </Label>
                  )}
                </List.Item>
              </List>
            )}
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

export default injectIntl(PhishingTemplateCopy);



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/PhishingTemplateCopy.js